import { CarePlanTrigger } from '@summer-health/types/care-plan';

export const carePlanTriggers: Record<string, CarePlanTrigger> = {};
